import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companyAnalysis: {
        SUMMARY: 'Summary',
        COMPANY_PROFILE: 'Company Profile',
        OWNERSHIP_AND_GROUP: 'Ownership & Group',
        FILING_STATUS: 'Filing Status',
        NEWS_AND_SOCIALS: 'News & Socials',
        FINANCIAL: 'Financial',
        FINANCIAL_STATEMENTS: 'Financial Statements',
        FINANCIAL_ANALYSIS: 'Financial Analysis',
        SCORE: 'Score',
        PEER_ANALYSIS: 'Peer Analysis',
        INDUSTRY: 'Industry',
        INDUSTRY_OVERVIEW: 'Industry Overview',
        INDUSTRY_ANALYSIS: 'Industry Analysis',
        common: {
          PORTFOLIOS: "Manage Company's Portfolios",
          DOWNLOAD: 'Download FiinGate Factsheet',
          ORDER: 'Order Business Credit Report',
          CREATE_DYNAMIC_REPORT: 'Create Dynamic Report',
          FOLLOW: 'Follow Alerts',
          FOLLOWING: 'Following Alerts',
          CURRENCY_UNIT: 'Currency & Unit:',
          MAIN_BUSINESS: 'Main Business:',
          TAX_CODE: 'Tax Code',
          TICKER_SYMBOL: 'Ticker Symbol',
          VIETNAMESE_NAME: 'Vietnamese Name',
          SHORT_NAME: 'Short Name',
          CREDIT_RISK_SCORE: 'Corporate Risk Score',
          CREDIT_RISK_SCORE_LABEL_UP: `The Company's %{link}  is trending upward.`,
          CREDIT_RISK_SCORE_LABEL_DOWN: `The Company's %{link}  is trending downward.`,
          CREDIT_RISK_SCORE_LABEL_STABLE: `The Company's %{link}  is stable.`,
          CREDIT_RISK_SCORE_LABEL_FIRST_TIME: `The Company's %{link} has been measured for the first time.`,
          CREDIT_RISK_SCORE_LABEL_NOT_AVAILABLE: `The Company's %{link} is not available at the moment.`,
        },
        SELECT_COMPARING_INDUSTRY: 'Select Comparing Industry',
        SELECT_DEFAULT_INDUSTRY: 'Select Default Industry',
        CORPORATE_RISK_SCORE: 'Corporate Risk Score',
        CORPORATE_PERFORMANCE_SCORE: 'Corporate Performance Score',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companyAnalysis: {
        SUMMARY: 'Tổng Quan',
        COMPANY_PROFILE: 'Thông Tin Công Ty',
        OWNERSHIP_AND_GROUP: 'Quan Hệ & Sở Hữu',
        FILING_STATUS: 'Tình Trạng Nợ Thuế',
        NEWS_AND_SOCIALS: 'Tin Tức',
        FINANCIAL: 'Thông Tin Tài Chính',
        FINANCIAL_STATEMENTS: 'Báo Cáo Tài Chính',
        FINANCIAL_ANALYSIS: 'Phân Tích Tài Chính',
        SCORE: 'Điểm Số',
        PEER_ANALYSIS: 'Phân Tích Ngang Hàng',
        INDUSTRY: 'Ngành',
        INDUSTRY_OVERVIEW: 'Tổng Quan Ngành',
        INDUSTRY_ANALYSIS: 'Phân Tích Ngành',
        common: {
          PORTFOLIOS: 'Quản Lý Danh Mục Của Công Ty',
          DOWNLOAD: 'Tải FiinGate Factsheet',
          ORDER: 'Đặt Business Credit Report',
          CREATE_DYNAMIC_REPORT: 'Tạo Dynamic Report',
          FOLLOW: 'Theo Dõi Cảnh Báo',
          FOLLOWING: 'Đang Theo Dõi Cảnh Báo',
          CURRENCY_UNIT: 'Tiền Tệ & Đơn Vị:',
          MAIN_BUSINESS: 'Lĩnh Vực Hoạt Động:',
          TAX_CODE: 'Mã Số Thuế',
          TICKER_SYMBOL: 'Mã Chứng Khoán',
          VIETNAMESE_NAME: 'Tên Nước Ngoài',
          SHORT_NAME: 'Tên Viết Tắt',
          CREDIT_RISK_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
          CREDIT_RISK_SCORE_LABEL_UP: `%{link} của doanh nghiệp đang có xu hướng tăng.`,
          CREDIT_RISK_SCORE_LABEL_DOWN: `%{link} của doanh nghiệp đang có xu hướng giảm.`,
          CREDIT_RISK_SCORE_LABEL_STABLE: `%{link} của doanh nghiệp ổn định.`,
          CREDIT_RISK_SCORE_LABEL_FIRST_TIME: `%{link} của doanh nghiệp được tính toán lần đầu.`,
          CREDIT_RISK_SCORE_LABEL_NOT_AVAILABLE: `%{link} hiện không có sẵn.`,
        },
        SELECT_COMPARING_INDUSTRY: 'Chọn ngành so sánh',
        SELECT_DEFAULT_INDUSTRY: 'Chọn ngành mặc định',
        CORPORATE_RISK_SCORE: 'Điểm Rủi Ro Doanh Nghiệp',
        CORPORATE_PERFORMANCE_SCORE: 'Điểm Tiềm Năng Tăng Trưởng',
      },
    },
  }),
)
